import styled from 'styled-components'
import { GRAY_DARK, BLUE, BLUE_SHADOW, WHITE_TRANSPARENT } from '../../../theme/colors'
import Input from 'antd/lib/input'

export const Container = styled.div`
  overflow-y: hidden;
  max-height: 734px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
`

export const DIYlabel = styled.p`
  background: #27E1FD;
  color: #302628;
  font-size: 12.5px;
  padding: 10px 30px;
  text-align: center;
  border-radius: 5px;
  margin: 2px 0 8px 0px;
`

export const ConfirmMessage = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
`

export const InputWrapper = styled.div`
  padding: 4px 0px;
  .ant-input:hover {
    border-color: ${BLUE};
  }

  .ant-input:focus {
    border-color: ${BLUE};
    outline: 0;
    -webkit-box-shadow: 0 0 0 2px ${BLUE_SHADOW};
    box-shadow: 0 0 0 2px ${BLUE_SHADOW};
  }

  .ant-input::selection {
    background: ${BLUE};
  }
`

export const StyledInput = styled(Input)`
  margin-bottom: 20px;
  margin-top: 0px;
  border-radius: 0px;
  width: 100%;
`

export const TransparentLoader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: ${WHITE_TRANSPARENT};
  height: 100%;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
`

export const LoadingContainerFix = styled.div`
  height: 100vh;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
`

export const PaginationRow = styled.div`
  [data-bottom="true"] {
    display: flex;
    flex-direction: column;
  }
  [data-bottom-label="yes"] {
    display: block;
  }
  [data-bottom-icon="yes"] {
    font-size: 22px;
  }
  flex: 1;
  width: 100%;
  max-width: 1486px;
  padding-right: 22px;
  padding-left: 22px;
  transition: all .25s;
  #results > ul > li {
    max-width: 14% !important;
    padding-bottom: 2px;
  }
  @media (min-width: 320px) and (max-width: 768px) {
    padding-right: 0;
    text-align: center;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/LockerTab/styledComponents.tsx